export const API_BASE_URL = 'https://dashboard-fayah.sitemapdev.co.ke';